import React from 'react';

const NewsBanner = () => {
  return (
    <section
      className="h-[55vh] sm:h-[70vh] md:h-[90vh] lg:h-[92vh] bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: "url('/images/news-banner.webp')"
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
      />

      {/* Banner Content */}
      <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
        <div className="text-center text-white max-w-6xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
            The latest insight and news<br />
            <span style={{ color: '#db0058' }}>from our team of experts.</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default NewsBanner;